import { cn, parseUTCDate } from '@/lib/utils'

/** Left padding that lines a message's body up with its sender's name, past the avatar. */
export const MESSAGE_BODY_INDENT = 'pl-14 pr-3 sm:pl-[3.75rem] sm:pr-4'

/** Header row of one message: avatar, sender line and time. */
export const MESSAGE_HEADER_ROW = 'flex items-start gap-3 px-3 py-2.5 sm:px-4'

export function formatMessageTime(dateStr: string) {
  const date = parseUTCDate(dateStr)
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    ...(date.getFullYear() === new Date().getFullYear() ? {} : { year: 'numeric' }),
    hour: 'numeric',
    minute: '2-digit',
  })
}

export function messageInitials(name: string) {
  const words = name.replace(/[<>@.].*$/, '').split(/\s+/).filter(Boolean)
  return ((words[0]?.[0] ?? '') + (words[1]?.[0] ?? '')).toUpperCase() || '?'
}

/** Classes for one clickable row in a conversation list (a button or a link). */
export function conversationListItemClass(selected: boolean) {
  return cn(
    'block w-full space-y-1 rounded-md px-2.5 py-2 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50',
    selected ? 'bg-background shadow-sm ring-1 ring-border' : 'hover:bg-background/70',
  )
}
